export default function UiHeader({title,subtitle}){
    return <div>
        <h2>{title}</h2>
        <h3>{subtitle}</h3>
        <hr/>
    </div>
}